import React from "react";
import { useTheme } from "../../../context/ThemeContext";

const Logo = (props) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? "/SECONDARY%20WHITE.png" : "/SECONDARY%20GREEN.png";

  return (
    <div {...props}>
      <img
        src={src}
        alt="ClickLaw logo"
        className="logo-public"
      />
    </div>
  );
};

export default Logo;
